import { useQuery } from "react-query";
import { fetchItem } from "@/queries/queries-helper.ts";
import ENDPOINTS from "../../../../../services/endpoints";
import IndicatorDefinition from "../../../../../models/enums/indicator-definition";
import IndicatorDto from "@/models/interfaces/dtos/indicators/indicator-dto.ts";

const usePackDetails = (packId: string) => useQuery<IndicatorDto | undefined>(
        ['pack-context', packId],
        async () => fetchItem<IndicatorDto>(ENDPOINTS.PACK_KEYNAME_INDICATORS(packId, IndicatorDefinition.CTX)));        

export default usePackDetails;